require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./section1.styl');

import React from 'react';

const dataSource = require('json!../main/data/daten_alltext.json');

class Section1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = ({
          sozialBeziehende: 0,
          sozialQuote: 0
        })

    }

    niceComma(value) {
      let str = value.toString();
      let newValue = str.replace(".",",");
      return newValue;
    }

    componentWillReceiveProps(props) {
      if(this.props.quarter != '') {

        // Calculate data when new props arrive

        for(let i=0; i<dataSource.length; i++) {

          if(dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {

            // console.log(dataSource[i])

            this.setState({
              sozialBeziehende: dataSource[i].SozialBeziehende,
              sozialQuote: dataSource[i].SozialQuote
            })

          }

        }

      }
    }


    render() {

      // console.log(this.props.quarter)

        return (

            <div className='section one wrapper'>

                <div
                  className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment mobile-padding`}
                  style={{padding: '0px 0px'}}
                >
                    <div className='ui inverted simple dimmer'></div>
                        {/*<h3>Mehr Armut als man denkt</h3>*/}
                            <p className='section-text'>Lernt Oliver eine Frau kennen, spricht er sofort Klartext: «Ich sage immer drei Dinge. Erstens: Ich bin arm. Zweitens: Ich bin krank. Drittens: …» Oliver stockt. Sein Blick ist glasig, seine Konzentration schwindet. Das Gespräch erschöpft ihn. <strong>Oliver leidet unter Narkolepsie</strong>, umgangssprachlich Schlafkrankheit genannt. Um seine Geschichte zu erzählen, hat er eine Extradosis Medikamente eingeworfen. «Ritalin», sagt er, und macht mit seinem rechten Unterarm eine Pumpbewegung, um den Effekt zu unterstreichen, den die Droge eigentlich haben sollte.

                            </p>

                            <p className='section-text'>
                              Oliver ist 45 Jahre alt, Bürstenschnitt, rundes Gesicht, breiter Nacken. Er trägt ein blaues T-Shirt und Jeans, wirkt unauffällig, einzig die leicht geröteten Augen fallen auf. Er sitzt in der Küche seiner Genossenschaftswohnung in der Stadt Zürich. An der Wand hängen Fotos, Zeichnungen und Postkarten von seinem Sohn. Oliver will anonym bleiben. Sein 9-jähriger Sohn soll auf dem Pausenplatz nicht wegen seiner Geschichte gehänselt werden.
                            </p>

                            <p className='section-text'>
                              Olivers Geschichte handelt von <strong>einem jahrelangen Kampf gegen die Armut</strong>, der lange Zeit verloren schien. Plötzlich hätten 326 Franken im Monat ausreichen müssen. Das Konto war leer, fünf Betreibungen waren hängig. Es reichte nicht. Der Reisvorrat war aufgebraucht und am nächsten Tag hätte sein Sohn zum Mittagessen kommen sollen. Das war vor etwas mehr als einem Jahr. «Da wusste ich, ich muss aufs Sozialamt», sagt Oliver. «Wissen Sie, wie sich das anfühlt?»
                            </p>

                            <p className='section-text'>
                              <strong>Armut ist in Zürich weitgehend unsichtbar</strong>, weil sie bloss die wenigsten zu einem Leben auf der Strasse zwingt. Nur während der Adventszeit, wenn die Hilfswerke um die Aufmerksamkeit potenzieller Spenderinnen und Spender buhlen, rückt sie etwas ins Bewusstsein der reichen Zürcherinnen und Zürcher – dann, wenn zwischen Weihnachtseinkäufen und Glühwein für 6.50 Franken der Zweifränkler im Heilsarmee-Topf scheppert.
                            </p>

                  <p className='section-text'>
                    19'748 Menschen haben in Zürich 2014 Sozialhilfe bezogen, wie <a href='https://www.stadt-zuerich.ch/epaper/PRD/SSZ/Jahrbuch/JB_2016_output/web/html5/index.html?&locale=DEU' target='_blank'>Zahlen von Statistik Stadt Zürich</a> zeigen. Das entspricht 5,1 Prozent.
                    { this.props.quarter != undefined && this.props.readerIsCityCitizen == true &&

                    <span className={`personalised text`}>Im Quartier {this.niceComma(this.props.quarter)} waren es {this.state.sozialBeziehende} Menschen ({this.niceComma(this.state.sozialQuote)} Prozent).</span>
                    }

                    &nbsp;<a href='https://www.bfs.admin.ch/bfs/de/home/statistiken/soziale-sicherheit/erhebungen/shs.html' target='_blank'>Schweizweit</a> und im <a href='http://www.statistik.zh.ch/internet/justiz_inneres/statistik/de/daten/daten_bevoelkerung_soziales/soziales.html' target='_blank'>Kanton Zürich</a> liegt die Sozialhilfequote bei 3,2 Prozent. Im Stadtkreis 12 ist die Sozialhilfequote mit 8,3 Prozent am höchsten. 2379 Menschen sind betroffen. Den tiefsten Wert weist der Stadtkreis 7 auf, 425 Menschen oder 1,2 Prozent. Zu den <a href='http://www.caritas-zuerich.ch/was-wir-sagen/zahlen-und-fakten-zur-armut-bei-uns' target='_blank'>Risikogruppen</a> gehören: Alleinerziehende, Unterhaltspflichtige, Familien mit drei und mehr Kindern, Alleinlebende, Migranten und Menschen mit geringer Bildung.
                            </p>

                          <p className='section-text'>
                            Anspruch auf Sozialhilfe hätten noch viel mehr. <a href='https://blog.bfh.ch/knotenmaschen/wer-wagt-es-nach-hilfe-zu-fragen/' target='_blank'>Eine Studie</a> hat gezeigt, dass in Städten etwa jeder Siebte, der Anspruch auf Sozialhilfe hätte, keine beantragt – <a href='http://www.tagesanzeiger.ch/schweiz/standard/Aus-Scham-auf-Sozialhilfe-verzichten/story/11945810' target='_blank'>aus Scham</a>, aus Stolz oder bei Ausländern auch aus Angst vor Konsequenzen für den Aufenthaltsstatus. Auf dem Land ist diese Zahl noch deutlich höher.                          </p>
                </div>

            </div>
        );
    }
}

Section1.defaultProps = {};

Section1.propTypes = {
    readerIsCityCitizen: React.PropTypes.bool,
    readerMadeHisChoice: React.PropTypes.bool,
    quarter: React.PropTypes.string,
    circle: React.PropTypes.string
}


export default Section1;



// WEBPACK FOOTER //
// ./src/components/section1/Section1.js